import styled from "@emotion/styled";
import { Box, Button } from "@mui/material";
import React, { useRef } from "react";

const VisuallyHiddenInput = styled("input")({
	clip: "rect(0 0 0 0)",
	clipPath: "inset(50%)",
	height: 1,
	overflow: "hidden",
	position: "absolute",
	bottom: 0,
	left: 0,
	whiteSpace: "nowrap",
	width: 1,
});

const defSX = {
	backgroundColor: "#000",
	color: "#fff",
	padding: "8px 16px",
	borderRadius: "999px",
	cursor: "pointer",
	"&:hover": { backgroundColor: "#333" },
};

const AddFileButton = ({ sx = defSX, name, onChange = () => {}, children }) => {
	// 1. Create a ref to access the file input element.
	const fileInputRef = useRef(null);

	// Handler for the button click event.
	const handleButtonClick = (e) => {
		// Stop event propagation to prevent the parent Box/label from also handling the click.
		e.stopPropagation();
		// 2. Programmatically click the hidden file input.
		fileInputRef.current.click();
	};

	return (
		<Box>
			{/* The onClick handler for the button will now be responsible for opening the file dialog. */}
			{children ? (
				React.cloneElement(children, {
					onClick: handleButtonClick,
				})
			) : (
				<Button onClick={handleButtonClick} sx={sx}>
					{name ?? "Upload File"}
				</Button>
			)}
			{/* Hidden File Input */}
			<VisuallyHiddenInput
				type="file"
				multiple
				onChange={onChange}
				// 3. Attach the ref to the file input.
				ref={fileInputRef}
				// The onClick handler below is commented out because it's not needed with the ref approach.
				// onClick={(e) => (e.target.value = null)}
			/>
		</Box>
	);
};

export default AddFileButton;
